module.exports = __webpack_public_path__ + "img/think_again.8fdebcca.png";